import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
const firebaseConfig = {
  apiKey: "AIzaSyBDAzydb6CUBFtx3hCjZ-Ewp3KjjdfhwTk",
  authDomain: "talae-sho.firebaseapp.com",
  projectId: "talae-sho",
  storageBucket: "talae-sho.appspot.com",
  messagingSenderId: "221580598128",
  appId: "1:221580598128:web:babc113d9f15460792cdb5",
  measurementId: "G-EXWCFXYG53",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
export const getFirebaseToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const token = await getToken(messaging);
    window.localStorage.setItem("pushToken", token);
    return token;
  } else {
    return null;
  }
};
